import Navbar from "../../../molecules/landing/layout/Navbar";
import Footer from "../../../molecules/landing/layout/Footer";
import WhatsAppButton from "../../../molecules/landing/layout/WhatsAppButton";
import { useLocation } from "react-router-dom";
import { useIsMobile } from "@/hooks/use-mobile";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const location = useLocation();
  const isMobile = useIsMobile();

  const isPropertyDetailPage =
    location.pathname.startsWith("/propiedades/") ||
    location.pathname.startsWith("/property/");

  const shouldShowWhatsAppButton = !(isMobile && isPropertyDetailPage);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Navbar />
      <main className="flex-1 pt-16">{children}</main>
      <Footer />
      {shouldShowWhatsAppButton && <WhatsAppButton />}
    </div>
  );
};

export default Layout;
